export default "__VITE_ASSET__BsAS3zqW__"